/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_Nav_DInputs */

const en_mk_sol_agensi_nav_d = /** @type {(inputs: Mk_Sol_Agensi_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many clients, many revisions, deadlines stacked on deadlines.`)
};

const id_mk_sol_agensi_nav_d = /** @type {(inputs: Mk_Sol_Agensi_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banyak klien, banyak revisi, tenggat yang saling tumpuk.`)
};

/**
* | output |
* | --- |
* | "Many clients, many revisions, deadlines stacked on deadlines." |
*
* @param {Mk_Sol_Agensi_Nav_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_nav_d = /** @type {((inputs?: Mk_Sol_Agensi_Nav_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_Nav_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_nav_d(inputs)
	return en_mk_sol_agensi_nav_d(inputs)
});